#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-12-11 13:22+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: fr\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {Nœud} other {nœuds}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0} sur {1} fichiers téléversés"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} sera supprimé définitivement."

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {bucket} other {buckets}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "{resourceTypeName} avec l’ID {id} introuvable"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 serveur bare metal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 jour"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 heure"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "Numéro mobile TrueMoney à 10 chiffres commençant par 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 jours"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 semaines"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 heures"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 jours"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "Une remise a été appliquée à tous les services associés à ce compte de facturation."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "Un compte utilisateur sera créé avec ce nom d’utilisateur. Il pourra être utilisé pour se connecter à la VM. Peut contenir des lettres ASCII, des chiffres, des tirets bas et des traits d’union. Doit commencer par une lettre ou un tiret bas. Longueur maximale : 25 caractères."

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Un réseau privé virtuel (VPC) est un réseau privé reliant des ensembles de vos ressources. Le réseau VPC est disponible sans frais supplémentaires."

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Accepter"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Accepter l'invitation"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Accepté"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Accepter cette invitation d'accès vous donnera l'autorisation d'agir en tant que « {name} » et d'effectuer toutes les opérations au nom de cet utilisateur."

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Accès"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Identifiants d’accès"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Délégation d'accès"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Groupe d’accès"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Un accès a été partagé avec vous"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Invitation d'accès"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "L’invitation d’accès de {0} est en attente"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "ID de la clé d’accès"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Nom de l'accès"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Portée d’accès"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Type d’accès"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Accéder à l’utilisateur"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Les détails du compte sont en cours de validation."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Les détails du compte doivent être validés"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "ID du compte"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Nom du compte"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Agir"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Vous agissez en tant que <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "Action requise"

#. Disk status
#. Service status
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Actif"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "Le coût réel de votre stockage est calculé à l’heure selon votre utilisation effective, sans paiement initial. Pour chaque Go entamé, le prix est arrondi au Go entier supérieur."

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "Le prix réel est déterminé par l’utilisation du calcul et du stockage. Les volumes persistants des clusters en hibernation continueront d’être facturés. Consultez l’utilisation actuelle du compte de facturation pour des informations plus détaillées."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Ajouter"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "Ajoutez un moyen de paiement compatible avec la recharge automatique."

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Ajouter un disque supplémentaire"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "Ajoutez au moins une règle de transfert"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "Ajoutez au moins un serveur cible"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "Ajouter une configuration personnalisée pour la machine virtuelle"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Ajouter un prénom"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Ajouter une IP"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Ajouter un nom de famille"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Ajouter un nom"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Ajouter un nouveau mode de paiement..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "Ajouter une nouvelle réservation"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Ajouter une nouvelle règle"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Ajouter un nœud"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Ajouter un pool de nœuds"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Ajouter un moyen de paiement"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Ajouter un mode de paiement plus tard"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Ajouter une règle"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "Ajouter une clé SSH"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Ajouter une sous-interface"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Ajouter un serveur cible"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Ajouter un utilisateur"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Ajouter des utilisateurs"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "Échec de l’ajout du moyen de paiement"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Adresse"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Complément d'adresse"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Vue administrateur"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "Tous"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "Toutes les adresses IP"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "Toutes les autorisations"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "Tout le trafic TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "Tout le trafic UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Allouez une adresse IP flottante et commencez à gérer votre réseau."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "Alloué"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "L’allocation d’une nouvelle adresse IPv4 vous permet de l’attribuer à l’une de vos ressources existantes ou de la réserver pour une utilisation ultérieure."

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "Vous avez déjà un compte ?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Montant"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "Montant facturé à l’avance"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "Le montant est trop faible"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "Le montant doit être positif"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "Le montant ne doit pas être inférieur au montant minimal de recharge"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "Un compte de facturation actif est nécessaire pour créer des ressources."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "Un compte de facturation actif est nécessaire pour utiliser cette fonctionnalité."

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "Un e-mail contenant des instructions vous a été envoyé."

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Une erreur s'est produite"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "N’importe lequel"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "Documentation de l'API"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "Jeton API"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "Catalogue d’applications"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Apparence"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Demander le paiement par facture"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "Voulez-vous vraiment supprimer la sous-interface avec l’UUID {ifUuid} ?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "Êtes-vous sûr de vouloir supprimer la clé publique \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "Voulez-vous vraiment vous déconnecter ?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Attribuer à"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Attribuée"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Attribué à"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "Au moins une adresse e-mail est requise"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "Au moins une adresse IP est requise"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "Au moins un pool de nœuds doit avoir une valeur minimale d’autoscaler de 1 ou plus."

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Associer un pare-feu"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Associer une ressource"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Attaché"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Attaché à"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Automatique"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Mise à jour automatique"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Paiement automatique"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Recharge automatique"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Les sauvegardes automatiques au niveau du système sont activées. Utilisez les images de sauvegarde pour restaurer votre service. Les sauvegardes seront conservées pendant 7 jours, ce qui signifie que vous disposerez des 7 dernières sauvegardes."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "Les sauvegardes automatiques au niveau du système sont activées. Utilisez les images de sauvegarde pour restaurer votre machine virtuelle ou créer une nouvelle machine virtuelle à partir de la sauvegarde avec des paramètres de taille modifiés."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Les mises à jour automatiques n’appliquent pas les versions en préversion."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Recharger automatiquement (min. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Max. de l’autoscaler"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Min. de l’autoscaler"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Disponible"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "Éveillé"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Retour"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Retour à votre compte"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Sauvegardes"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Historique du solde"

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Bare metal"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Serveur bare metal"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Devise de base"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Commencez votre processus de validation du compte de facturation."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "Ci-dessous un exemple de configuration de cette sous-interface sur un serveur Linux."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "Facturé"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Facturation"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Compte de facturation"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "Le compte de facturation « {title} » bénéficie d’une remise de {discount_percentage} %"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "Le compte de facturation est limité"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Nom du compte de facturation"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "Remplacement du compte de facturation"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Billing account suspended"
msgstr "Compte de facturation suspendu"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "La validation du compte de facturation a été refusée"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Comptes"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "Cycle de facturation"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Amorçable"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Démarrer à partir d’un support ISO"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "Mode de démarrage"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "Le démarrage n’est possible que lorsque la machine virtuelle est arrêtée."

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "par {gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "En poursuivant la recharge, vous acceptez les <0>Conditions générales</0>, la <1>Politique de confidentialité</1> et la <2>Politique de remboursement</2>."

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "En désactivant les sauvegardes, aucune autre sauvegarde automatique ne sera effectuée pour votre machine virtuelle. Les sauvegardes déjà réalisées seront conservées en l’état et resteront utilisables. Vous pourrez réactiver les sauvegardes à tout moment si nécessaire."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "En sélectionnant « Global », toutes les ressources de ce compte utilisateur seront accessibles. Faites preuve de prudence lors du choix de la portée « Global »."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "En sélectionnant « Restreint », l'accès sera limité aux ressources appartenant au compte de facturation sélectionné."

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "En vous inscrivant, vous acceptez les <0>Conditions d’utilisation</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Code de campagne"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Peut m'accéder"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Annuler"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Annuler les téléversements"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "Annulé"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Numéro de carte"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "La vérification de la carte a échoué"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Modifier"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Changer le mot de passe"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Modifiez votre mot de passe en cliquant sur le lien de vérification que nous venons d’envoyer dans votre boîte de réception."

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "Échec du changement de mot de passe"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "La modification du mot de passe n’est possible que lorsque la machine virtuelle est en cours d’exécution."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Choisissez un compte de facturation pour votre nouvelle ressource afin de regrouper vos ressources sous un moyen de paiement adapté."

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Choisissez un compte de facturation auquel vous souhaitez partager l'accès"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Choisissez une ressource à laquelle attribuer l’IP ou laissez-la non attribuée. Vous pourrez toujours attribuer l’IP à une ressource appropriée plus tard"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "Choisissez une machine virtuelle à laquelle attacher le disque, ou laissez-le détaché et connectez-le à une machine virtuelle ultérieurement."

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Choisissez un réseau VPC pour votre ressource parmi ceux existants ou créez un nouveau réseau privé."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Choisir un compte"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Choisir le mode de paiement"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "Choisissez le réseau VPC dans lequel se trouvent les serveurs cibles."

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "Choisissez UEFI si la VM que vous importez l’exige."

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Ville"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Nettoyage"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Tout effacer"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "Supprimer le remplacement"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Effacer les téléversements"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "Cliquez sur le bouton pour vous connecter à PayPal."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Cloner"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Cloner la ressource"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Fermer"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "Code :"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "Engagé"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Nom de l'entreprise"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Numéro RNE de l’entreprise"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "Un manuel API complet avec des exemples de code est disponible ici :"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Calcul"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "Configurer le mien"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Confirmer l’adresse e‑mail"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Confirmer le mot de passe"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Confirmez votre adresse e‑mail en cliquant sur le lien de vérification que nous venons d’envoyer dans votre boîte de réception."

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Confirmation"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Se connecter"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "Connectez-vous d’abord à PayPal"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Connexion en cours"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Connexion du mode de paiement"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Détails de connexion"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Nom de la personne de contact"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Téléphone de la personne de contact"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Contacter le support"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Continuer"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "Copié !"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Copier"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Copier la configuration dans le presse-papiers"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Copier l’URL publique"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Copier dans le presse-papiers"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Services de base"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "Pays"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "Comté"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Créer"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "Créer"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Créez d’abord un compte de facturation, puis vous pourrez commencer à créer des ressources."

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Créez un serveur bare metal dédié et exécutez votre application avec des performances maximales."

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "Créer un(e) nouveau/nouvelle {resourceTypeName}"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Créez un nouvel accès pour permettre à d’autres utilisateurs ou systèmes d’effectuer des actions avec ce compte {siteName}."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Créez un nouveau disque et commencez à stocker vos données."

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Créez une nouvelle ressource et lancez vos services en quelques minutes."

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Créez une nouvelle ressource et commencez à gérer votre réseau."

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Créez un nouveau service et mettez-le en service en quelques minutes."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Créez un nouveau compte de stockage, créez des buckets et commencez à stocker vos données de manière évolutive — payez à mesure de votre croissance."

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "Créez un nouveau compte de stockage, créez des buckets et commencez à stocker vos données."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Créez une nouvelle machine virtuelle ou choisissez un élément dans le catalogue d'applications pour lancer vos services en quelques minutes."

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Créez un VPC personnel et commencez à gérer vos réseaux."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Créer une adresse IPv4 publique pour la ressource"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "Créez du stockage supplémentaire pour vos charges de travail. Configurez le disque et attachez-le à une machine virtuelle maintenant ou ultérieurement."

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Créer un compte"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Créez un jeton API pour utiliser notre API."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Créer un autre {0}"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Créer un compte de facturation"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Créer un nouvel élément"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Créé"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Créé le"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Date de création"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "Créé à partir de"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Création en cours"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "Créer un accès via un jeton API vous fournit une clé à utiliser avec notre API."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Crédit"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "Avoir {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "Actuel"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "Cycle de facturation actuel"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "Les modifications actuelles seront supprimées."

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Consommation actuelle"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Actuellement indisponible"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Personnalisé"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Image ISO personnalisée"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "Assistance clientèle"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Sombre"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Tableau de bord"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Centre de données où se trouve la ressource"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Centre de données où la ressource sera créée."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Données manquantes"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Date"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Refusé / Suspendu"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Par défaut"

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Déléguer l'accès à"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Déléguez l'accès à votre compte utilisateur ou de facturation afin que des utilisateurs de confiance puissent gérer vos ressources."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Déléguer un nouvel accès"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Déléguer l'accès à un utilisateur de confiance sélectionné lui permet d'agir en votre nom et d'effectuer toutes les opérations pour votre utilisateur ou votre compte de facturation."

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Supprimer"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Supprimer l’adresse IP flottante"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Supprimé"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "La suppression de « {display_name} » entraînera sa suppression définitive ; il ne sera plus accessible par la suite."

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "La suppression de « {display_name} » détruirait une ressource qui a déjà été payée. Veuillez contacter le support pour obtenir de l’aide."

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "La suppression de « {name} » retirera définitivement à tous les utilisateurs de ce groupe l’accès leur permettant d’agir en votre nom."

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "Suppression de {count} {0, plural, one {item} other {items}}."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "La suppression d’une sauvegarde la retirera définitivement."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "La suppression du compte de facturation « {title} » l’effacera définitivement. Un compte de facturation ne peut être supprimé que s’il n’y a aucune ressource impayée qui y est rattachée et s’il ne reste aucun crédit non utilisé."

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "La suppression du moyen de paiement « {0} » le retirera du compte de facturation."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "La suppression d’un service supprimera également vos sauvegardes et le service ne pourra plus être restauré ensuite."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "La suppression d’un instantané le supprimera définitivement."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "La suppression de la clé d’accès « {accessKey} » la supprimera définitivement ; elle ne pourra plus être utilisée pour accéder à l’API de stockage."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "La suppression de la carte de crédit « {placeholder} » la retirera définitivement du compte de facturation."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "La suppression du disque l’éliminera définitivement et il ne sera plus accessible par la suite."

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "La suppression de l’adresse IP flottante « {0} » la retirera de votre compte et la remettra dans le pool public."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "La suppression du mode de paiement par facture le retirera définitivement du compte de facturation."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "La suppression du service « {display_name} » le supprimera définitivement et il ne sera plus accessible par la suite."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "La suppression du compte de stockage « {title} » le supprimera définitivement et supprimera toutes les clés associées. Les comptes comportant des buckets actifs ne peuvent pas être supprimés."

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "La suppression du bucket de stockage « {name} » le supprimera définitivement ; les fichiers qu’il contient ne seront plus accessibles ensuite."

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "La suppression du jeton « {description} » le supprimera définitivement et il ne pourra plus être utilisé pour l’authentification."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "La suppression de la machine virtuelle « {name} » entraînera sa suppression définitive, et elle ne sera plus accessible par la suite."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "La suppression de la machine virtuelle supprimera également vos sauvegardes et instantanés, et la machine ne pourra plus être restaurée ensuite. Si vous souhaitez conserver les sauvegardes et les instantanés, envisagez plutôt d’arrêter la machine."

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "La suppression du réseau VPC « {name} » le retirera de votre compte."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Description"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Destinations"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Détaché"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Désactiver"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Désactiver les sauvegardes"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Désactiver la MFA"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Désactivée"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Se déconnecter"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Déconnecté"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Remise"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Disque"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "E/S disque"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "La taille du disque ne peut être qu’augmentée. Cette action est irréversible. Taille minimale du disque :"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Disques"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Devise d'affichage"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "Nom d’affichage"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Document"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "Fichier du document"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "N° de document"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Télécharger"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Télécharger le fichier de configuration"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Télécharger le PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Déposez des fichiers ici"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Date d’échéance"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "E‑mail"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Modifier"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "Modifier « {title} »"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Modifier la maintenance"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "Modifier le nom"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Modifier le nœud"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Modifier la règle"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "E-mail"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "Ce domaine d’adresse e‑mail n’est pas autorisé"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "Échec de la vérification de l’adresse e‑mail"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "Adresse e‑mail vérifiée"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "Adresse e-mail où les factures et les rapports sont envoyés."

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "Disque vide (pour démarrage depuis une image ISO)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Activer"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Activer la MFA"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Permettez à d’autres utilisateurs ou systèmes d’effectuer des actions sur les ressources liées à ce compte."

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Activée"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "Date de fin"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "Port de fin"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "Le port de fin doit être supérieur au port de début"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "Terminé"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Saisissez une valeur comprise entre 1 et 4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "Saisissez uniquement des chiffres"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Saisissez le montant de la recharge en {0} (minimum {minimumAmount}) :"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Erreur"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Erreur lors de l’ajout du moyen de paiement"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "Code d’erreur : {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "Erreur lors de l'exécution de l'action"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "Erreur lors de l’enregistrement des modifications"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "Coût estimé par sauvegarde"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Coût mensuel estimé"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Total estimé"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "Coût estimé"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "Le prix estimé par sauvegarde est de {priceWithDiscount} par mois."

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "Le prix estimé par instantané est de {priceWithDiscount} par mois."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Chaque nouvel utilisateur reçoit des crédits offerts d’une valeur de {c_totalReceiverCredit} en s’inscrivant via le lien ou le code de parrainage et en ajoutant un mode de paiement vérifié."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Chaque nouvel utilisateur qui s’inscrit via le programme de parrainage et recharge au moins {c_minimumTopUp} recevra un bonus d’une valeur de {c_totalReceiverCredit} en crédits."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Exemple"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Taux de change"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "Hors {vatSymbol}"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Nœuds de basculement"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "Échec de la connexion au serveur"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Échec du chargement de la bibliothèque Digio"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "Échec du chargement de la bibliothèque PayPal"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "Impossible d’ouvrir la fenêtre pop-up, un bloqueur de pop-ups est peut-être activé"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "Fichier"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "Fichiers"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "Les fichiers seront téléversés vers"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Pare-feu"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "Le pare-feu est disponible sans frais supplémentaires."

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Nom du pare-feu"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "Pare-feu désormais disponible"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Prénom"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Options"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "Adresse IP flottante"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Dossier"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Nom du dossier"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "Pour chaque nouvel utilisateur qui s’inscrit via le programme de parrainage et recharge au moins {c_minimumTopUp}, vous recevrez des crédits offerts d’une valeur de {c_promoterCredit}."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "Pour chaque nouvel utilisateur qui s’inscrit avec votre code de parrainage et ajoute un mode de paiement vérifié, vous recevrez des crédits offerts d’une valeur de {c_promoterCredit}."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "Pour un compte de facturation en paiement à l'usage, vous pourrez sélectionner le mode de paiement après la création et la validation du compte."

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "Pour les instantanés, vous ne payez que le stockage utilisé par l’instantané."

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Arrêt forcé"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "Mot de passe oublié"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Règles de transfert"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Gratuit"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Fréquence"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "à partir de"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "Depuis"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Chemin complet"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "Base de données entièrement gérée afin que vous puissiez vous concentrer sur votre code."

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Services entièrement gérés - nous nous chargeons du provisionnement de l'infrastructure sous-jacente et de la gestion du service."

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "Futur"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "Passerelle"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "Go"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "Go de disque"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "Go de RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "Go-h"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "Générer (recommandé)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Générez un jeton d’accès API pour utiliser notre <0>API</0>."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Global"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "Aller au tableau de bord"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "Numéro GST"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "Bonjour"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "Bonjour le monde !"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "Hiberner"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "Hiberné"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Hibernation en cours"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Masquer"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Masquer les détails"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "Un équilibreur de charge à haute disponibilité distribue le trafic entre les machines virtuelles au sein du même centre de données."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "heure"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "Horaire"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "Cycle de facturation horaire uniquement"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Consommation mise à jour toutes les heures pour la période de facturation en cours."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "J'ai accès à"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "J’ai lu et j’accepte les <0>Conditions d’utilisation</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Je reconnais que la suppression est définitive"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "Si les notifications de solde faible sont activées et que le solde passe sous le seuil, vous serez averti."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "Si la réservation active arrive à expiration et n’est pas renouvelée, la tarification horaire standard sera appliquée."

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "Si le mode de paiement par facture n’est pas activé immédiatement, nous vous contacterons avec plus de détails. Si vous ne recevez pas rapidement d’e-mail de notre part ou si le paiement par facture ne devient pas actif, vous pouvez nous contacter à <0/>."

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Si vous avez des questions, avez trouvé un bug ou souhaitez demander une fonctionnalité, n'hésitez pas à nous contacter via le <0>support</0>."

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "Dans tous les calculs, un nombre précis d’heures est utilisé : 730 pour un mois, 2 190 pour un trimestre et 8 760 pour une année."

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "En cours d’utilisation"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Inactif"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "entrant"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Règles entrantes"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "Inclus dans le prix de la machine virtuelle"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "Le trafic entrant n’est autorisé que vers les ports spécifiés s’il provient des sources spécifiées. Tout autre trafic sera bloqué."

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "Nom informatif. Il sera également utilisé pour générer un nom d’hôte approprié pour la VM (le cas échéant)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Infrastructure"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "Script d’initialisation"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Saisir le code"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Saisissez l’e-mail de l’utilisateur {siteName} à qui vous souhaitez déléguer l’accès. L’utilisateur devra accepter l’invitation d’accès depuis sa page de profil."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Solde insuffisant"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "Identifiant d'intégration"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "Mois invalide"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "Réponse du serveur invalide. Bloquée par Stormwall."

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "Type de réponse du serveur invalide : {ct} reçu au lieu de JSON."

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "Inscription invalide. Le compte existe peut-être déjà."

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "Année invalide"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Invoice"
msgstr "Facture"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "Facture {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Informations de facturation"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "E-mail de facturation"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "La facture a été payée"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "La facture ne peut pas être payée"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "Nom de la facture"

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Factures"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "Adresse IP"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "Adresse IP ou plage CIDR"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Liste d'adresses IP autorisées"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "Préfixes IP"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "Plage IP"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "Plage IPv4"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "Plage IPv6"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "Démarrage ISO"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Date d’émission"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Émise"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Conserver l’adresse IP flottante"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Veuillez noter que toutes les actions seront enregistrées et pourront vous être attribuées."

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "Nom de la clé"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Version de correctif de Kubernetes"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Mise à jour automatique de la version de correctif de Kubernetes"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Le service Kubernetes ne peut pas être créé."

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Langue"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Dernière modification"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Nom de famille"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Dernière sauvegarde"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Dernier instantané"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Moins de détails"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Clair"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "La limite sera levée une fois que le montant total des recharges atteindra <0/>."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Limité"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Ressources liées"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "prix catalogue"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Équilibreur de charge"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Charger plus"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Chargement du prestataire de paiement"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Chargement..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Emplacement"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Se connecter"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Se connecter avec Google"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Se déconnecter"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "Connexion"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "Erreur de connexion"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Parcourez d'abord"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "La notification de solde faible n’est pas effective, car la recharge automatique est activée."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Notifications de solde faible"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Détails de la machine"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "La machine est disponible pour une location immédiate par les clients."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "La machine est utilisée par le client et est facturée."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "La machine a été commandée par un client, mais ne satisfait pas la configuration requise.<0/>Une fois configurée comme nécessaire, passez au statut « En cours d’utilisation »."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "La machine est indisponible ou nécessite des réparations."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "La machine requiert des opérations de nettoyage des disques."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Type de machine"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Maintenance"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Gérer"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Gérer les clés API"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Service managé"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Services managés"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Surcapacité max."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Agrandir"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "La taille maximale de fichier à téléverser est de {maxFileSizeInMB} Mo"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "Mo"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "Mo/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Moyen de paiement"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "Modes de paiement disponibles après validation"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Métriques"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Les métriques pour cette ressource ne sont pas chargées pour des raisons de performances"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "La MFA est activée pour votre compte."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Réduire"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "Introuvable"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Mode"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "mois"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "Mensuel"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Coût mensuel"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "Plus de détails"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Authentification multifacteur (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "N/A"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Nom"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Nom (min. {minChars} caractères)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "Le nom est trop court"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "Besoin d’aide ?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Réseau"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Bande passante réseau"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Interfaces réseau"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Réseau"

#: src/components/sidebar/SidebarList.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Nouveau"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "Nouveau nom de fichier"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "Nouveau dossier"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "Nouveau nom de dossier"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "Nouveau réseau"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "Nouveau mot de passe"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "Nouvelle clé SSH"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "Identifiant client NForce"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "Aucune carte active"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "Aucune donnée"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "No Fail-over"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "Personne ne peut encore accéder à votre compte utilisateur"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "Personne n'a encore partagé d'accès avec vous"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "Aucun paiement ne sera effectué pour le moment. Vous pouvez changer votre mode de paiement à tout moment."

#: src/components/empty.tsx
msgid "No records"
msgstr "Aucun enregistrement"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "Aucun cycle de facturation de réservation n’est disponible pour ce serveur."

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "Aucun résultat"

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "Nombre de buckets"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "Nombre de fichiers"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "Nombre de ressources"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "Nombre de règles"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Nœud"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Pool de nœuds"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Pools de nœuds"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "nœuds"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Remarque : Si vous supprimez un nombre important d’éléments, le processus de suppression peut entraîner un état incohérent, où certains éléments sont supprimés tandis que d’autres restent. Le cas échéant, veuillez répéter la même action."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Remarque : Si votre dossier contient un nombre important de fichiers, le renommage prendra du temps et peut entraîner un état incohérent où certains fichiers sont déplacés vers le nouvel emplacement tandis que d'autres restent dans l'ancien dossier. Le cas échéant, veuillez répéter l'action en renommant à nouveau le même dossier."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Remarque : Le propriétaire saura si vous avez accepté cette invitation. Il ne pourra pas accéder à votre compte utilisateur ni voir ou modifier vos ressources."

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Notifications"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Notifier lorsque le solde passe en dessous de"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Avertir lorsque le solde passe sous le seuil suivant. Gardez à l'esprit que la limite réelle est définie dans la devise de base."

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "Disponible dès maintenant"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Hors ligne"

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Une fois par jour"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Une fois par semaine (le mercredi à 02:00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "L’un de vos comptes de facturation présente un problème et vos buckets ont été suspendus. Consultez les <0>détails du compte de facturation</0> pour plus d’informations ou contactez l’assistance pour résoudre le problème."

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "En cours"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Solde en cours"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "En ligne"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Uniquement les moyens de paiement automatiques"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "Seul le disque de démarrage sera créé ! Cela peut empêcher le bon démarrage de l’OS si la configuration de l’OS de l’instantané source exige la présence de disques supplémentaires."

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Système d’exploitation"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Mise à jour automatique du système d’exploitation"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "Ou"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Commande"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Commandes"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "sortant"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Règles sortantes"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "Le trafic sortant n’est autorisé que vers les ports spécifiés des destinations spécifiées. Tout autre trafic sera bloqué."

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Montant impayé"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Payé"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Paramètres"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Mot de passe"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Mot de passe pour l’utilisateur. Doit contenir au moins une lettre ASCII minuscule et une majuscule (a-z, A-Z) et au moins un chiffre (0-9). La longueur minimale est de 8 caractères."

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Les mots de passe ne correspondent pas"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "Passé"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "URL de type chemin"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "Payer"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Payer la facture"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Payer maintenant"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "Paiement à l'usage (recommandé)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
msgid "Paying by invoice"
msgstr "Paiement sur facture"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Paiement sur facture (refusé / suspendu)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Paiement sur facture (en attente)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "Vérification de l'autorisation de paiement terminée."

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "Paiement annulé"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "Paiement annulé en raison d’un risque élevé"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Détails de paiement"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "Erreur de paiement"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "Erreur de paiement : {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "Le paiement a échoué"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment method"
msgstr "Mode de paiement"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Moyens de paiement"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "Le traitement du paiement avec ce mode prend du temps. Le crédit acheté sera automatiquement ajouté à votre compte une fois le processus terminé."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Type de paiement"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "Le paiement a été annulé"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "pc"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "En attente"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Période"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Autorisations"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Numéro d'identification personnel"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Numéro de téléphone"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "Fournies par la plateforme"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "Veuillez reconnaître que le compte de facturation ne sera pas activé avant qu’un administrateur ait accepté votre demande."

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Veuillez autoriser les fenêtres contextuelles pour utiliser ce moyen de paiement"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Veuillez patienter"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "Veuillez effectuer le paiement dans la fenêtre contextuelle."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Veuillez contacter le support pour lever la limite."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Veuillez contacter les administrateurs pour plus de détails."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Veuillez continuer."

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Veuillez saisir un nom valide"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Veuillez saisir votre adresse e‑mail. Nous vous enverrons un e‑mail pour réinitialiser votre mot de passe."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Veuillez terminer l’ajout de l’adresse e-mail"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "Veuillez noter que le compte de facturation lié à votre bucket de stockage diffère de celui associé à votre compte de stockage. Nous vous recommandons vivement de les harmoniser afin de garantir une facturation cohérente et une gestion plus claire."

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Veuillez consulter la manière dont le coût de votre ressource est calculé."

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "Veuillez sélectionner un réseau VPC pour choisir les serveurs cibles."

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Veuillez sélectionner un élément dans la liste"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Veuillez téléverser une copie du document d'immatriculation de l'entreprise ou de votre pièce d'identité pour vérification (max. {maxFileSizeInMB} Mo)."

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "Les pods et les services hébergés sur ce cluster seront arrêtés et tout stockage éphémère sera supprimé."

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "La fenêtre pop-up n’est pas revenue après la redirection"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "La fenêtre pop-up a été fermée avant d’avoir pu se charger"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Port"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "Le port doit être compris entre 1 et 65535"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Plage de ports"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "La configuration multi-nœuds PostgreSQL est une configuration primaire/secondaire avec basculement automatique."

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "Ressources prépayées"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Prépaiement"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Prix"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Grille tarifaire"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "Prix par cycle"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Prix par heure"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Prix par mois"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Les prix peuvent varier selon les options ci-dessous"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Principal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Privé"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "Images privées"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "Adresse IP privée"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "IPv4 privée"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Réseau privé"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "Un problème est survenu avec l’API PayPal."

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Profil"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Protocole"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "Fournissez une configuration cloud valide au format JSON ou YAML. Cette configuration sera transmise à la machine virtuelle en tant que données utilisateur cloud-init. Consultez la documentation cloud-init relative à la configuration cloud pour connaître toutes les options disponibles."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "Début de la fenêtre de maintenance du fournisseur durant laquelle le fournisseur peut planifier des mises à jour automatiques du cluster."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Public"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Les adresses IP publiques sont gérées dans la vue Réseau."

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "IPv4 publique"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "IPv6 publique"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "Clé publique"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "Partie publique de la paire de clés SSH permettant de se connecter à la machine virtuelle. Doit être au format <0>ssh-key-type base64encoded...key optional_comment</0>."

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Réseau public"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "URL publique"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Qté."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "trimestre"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "Trimestriel"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "Lien RDP"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "En savoir plus"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "Lecture seule"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Disponibilité"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Prêt"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Redémarrer"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Récents"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Redirection vers la passerelle de paiement"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Code de parrainage"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Lien de parrainage"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Programme de parrainage"

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Actualiser l'état"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Numéro d'immatriculation"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Réinstaller"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "La réinstallation de « {name} » détruira toutes les données du disque de démarrage et le remettra dans l’état initial du système d’exploitation. Tous les instantanés et sauvegardes sont conservés."

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Recharger"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Recharger les données"

#: src/root.tsx
msgid "Reload page"
msgstr "Recharger la page"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Crédit restant <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Retirer la ressource"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Retirer l’attribution de l’adresse IPv4 publique de cette ressource la rendra inaccessible depuis Internet. L’adresse IP restera réservée sur votre compte. Vous pouvez gérer les adresses IPv4 publiques depuis le menu Réseau dans la barre latérale gauche."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "La suppression de l’utilisateur révoquera le droit de « {0} » d’agir en votre nom."

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Renommer"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Rapport"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Rapport {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Rapports"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "Demandé"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "Réservations"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Réservé"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "Réservé et prépayé jusqu’au <0/> (il reste {daysRemaining} jours). Prix affiché sous forme d’équivalent mensuel."

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Réinitialiser le mot de passe"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Redimensionner"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Redimensionner le disque"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "Le redimensionnement n’est possible que lorsque la machine virtuelle est arrêtée."

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Nom de la ressource"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Ressources"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "les ressources dans le même réseau VPC utilisant les adresses privées des interfaces principales"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "les ressources dans les VPC partagés par des sous-interfaces VLAN en utilisant leurs adresses privées respectives"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "La réponse semble prendre plus de temps que prévu. Patientez un instant et actualisez la page pour voir les changements apparaître. Le résultat peut être un succès ou un échec."

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "La réponse semble prendre plus de temps que prévu. Patientez un instant et actualisez la page pour voir les changements de statut du paiement. Si cela ne se produit pas dans un délai raisonnable, veuillez contacter le support."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Restaurer"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "Restaurer à partir d'une sauvegarde"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "Restaurer à partir d'un instantané"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "La restauration depuis une sauvegarde remplacera l’état du service par l’état de la sauvegarde sélectionnée."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "La restauration de cette sauvegarde écrasera l’état actuel."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "La restauration de cet instantané écrasera l’état actuel."

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Restreint"

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "Rétention"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Réessayer"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "Révolutionnez votre cloud avec AMD EPYC"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "Document RNE"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Les règles de tous les pare-feux associés sont combinées ; une connexion est autorisée s’il existe au moins une règle qui l’autorise."

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Exécutez vos applications sur des serveurs bare metal pour un contrôle total, une sécurité renforcée et des performances brutes. Provisionnez un serveur dédié optimisé pour vos cas d’usage les plus exigeants."

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "En cours d’exécution"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "Le stockage d’objets compatible S3 vous permet de faire évoluer vos ressources de stockage à la hausse comme à la baisse sans paiement initial. Créez un nouveau compte de stockage, créez des buckets et commencez à stocker vos données de manière évolutive — payez à mesure de votre croissance."

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Enregistrer"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Enregistrement des informations de paiement"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Scannez le code QR pour payer"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Portée"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "Rechercher"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Clé d’accès secrète"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Sélectionner un fichier"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Sélectionnez un mode de paiement"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Sélectionnez une option"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Sélectionnez votre devise d'affichage pour voir les prix dans la devise de votre choix. Les montants affichés et les taux de change sont indicatifs et fournis à titre informatif uniquement. Toutes les transactions sont traitées dans la devise de base ({0}) et les montants finaux peuvent varier selon les taux appliqués par votre prestataire de paiement."

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Sélectionnez votre devise préférée"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Envoyer Ctrl+Alt+Suppr"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Envoyer l’e‑mail"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Serveur"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Classe de serveur"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Service"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Nom du service"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Services"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Définir par défaut"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Définir l'ACL de l'objet sur 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Définir l'ACL de l'objet sur 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Partager"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Partager sur Facebook"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "Partager sur LinkedIn"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "Partager sur X"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Partager temporairement"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Durée du partage"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Afficher"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Afficher les détails"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Affichage des {limit} derniers éléments"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "Affichage des prix catalogue. Remise appliquée dans le récapitulatif des coûts."

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "S’inscrire"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "S’inscrire avec Google"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Taille"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Taille (Go)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Instantanés"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Partage sur les réseaux sociaux"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Épuisé"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Trier"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Trier par"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Trier par date"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Trier par nom"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Trier par taille"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Port source"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "Le port source doit être unique"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Sources"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "La clé SSH ne correspond pas au format requis"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "Clés SSH"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "Les clés SSH peuvent être gérées dans votre <0>profil utilisateur</0>."

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "Lien SSH"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "SSH peut ne pas être disponible pour l’utilisateur root en raison de la configuration initiale du système d’exploitation. Veuillez utiliser la console virtuelle pour accéder au système et effectuer les modifications de configuration du serveur SSH selon vos besoins."

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Démarrer"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "Date de début"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Commencer ici"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Commencez à gérer vos réseaux en créant une nouvelle ressource réseau."

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "Port de début"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "Le port de début doit être unique"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Commencer quelque chose de nouveau"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Heure de début"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Initialisation du paiement"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "État"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Statut"

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Arrêter"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Arrêté"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Arrêt en cours"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Stockage"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Clés d’accès au stockage"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "Compte de stockage"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Bucket de stockage"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Nom du bucket de stockage"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "Buckets de stockage"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Adresse"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "Chaîne"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "Plage du sous-réseau (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Sous-total"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "Support"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "Suspendu"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Passer à la vue grille"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Passer à la vue liste"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "système"

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Créez un instantané pour capturer l’état actuel de votre machine virtuelle. Vous pourrez ensuite utiliser cet instantané pour restaurer l’état de votre machine virtuelle ou créer une nouvelle machine virtuelle à partir de l’instantané avec des paramètres de taille modifiés."

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Créer un instantané"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Effectuez une action et vous ne verrez plus jamais ce cactus."

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Port cible"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Serveurs cibles"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Console"

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Conditions d’utilisation"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "Le coût réel de votre ressource est calculé à partir des prix ci-dessous et de votre utilisation horaire réelle. Tous les prix s’entendent par unité de ressource (1 vCPU ou 1 Gio). Les prix sont indiqués hors taxes."

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "Le compte de facturation a été clôturé et n’est plus disponible."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "Le code de campagne n’est activé qu’après une recharge réussie."

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "L’ensemble de l’interface basculera et se comportera comme si vous étiez cet utilisateur. Une fois terminé, vous pouvez mettre fin à la session en cliquant sur le bouton « Retour à votre compte » dans la barre d’en-tête ; l’interface repassera alors sur votre compte."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "Le taux de change final et le montant débité seront déterminés au moment du paiement effectif."

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "Votre première recharge débloquera un crédit offert de <0><1/></0>."

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "Le format est MM/AA"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "Le lien expire le :"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "Le nom ne peut contenir que des caractères alphanumériques minuscules et des tirets ; il doit commencer par une lettre minuscule ou un chiffre ; la longueur autorisée est de 3 à 63."

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "Le mot de passe peut être modifié pour tout compte utilisateur existant."

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "Numéro de téléphone/mobile à contacter en cas de problème"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "Le prix est approximatif ; le coût de votre ressource sera calculé en fonction de votre utilisation horaire réelle."

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "Le mot de passe ressaisi, pour s’assurer qu’il a été saisi correctement."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "Le compte de facturation sélectionné ne dispose pas d’un crédit suffisant pour acheter cette réservation."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "Le compte de facturation sélectionné est limité et ne peut pas créer de réservations."

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "Le sous-réseau doit être inclus dans l’un des blocs IP suivants :"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "Le compte utilisateur pour lequel le mot de passe sera défini."

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Une erreur s’est produite lors de la vérification de votre adresse e‑mail."

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "Une erreur est survenue lors de la création de votre ressource."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "Ces identifiants ne servent qu’à la première connexion. Il est recommandé de les modifier immédiatement."

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "Ce/Cette {resourceTypeName} n’existe plus"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "Ce serveur bare metal est encore en cours de configuration."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "Ce compte de facturation dispose de capacités limitées pour créer des ressources."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "Ce compte de facturation est limité"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "Cette distribution ajoute un coût horaire de <0/> pour la licence (<1/> par mois)."

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "Ce champ est obligatoire"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "Cette clé donne accès à tous les buckets de ce compte de stockage. Pour restreindre l’accès à des buckets spécifiques, créez un compte de stockage distinct."

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "Cette page n’existe plus"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "Ce service n’est accessible que par des ressources du même réseau VPC en utilisant ces adresses privées."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "Cette machine virtuelle est accessible par :"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "Cela supprimera le pare-feu et ses règles associées, qui ne s'appliqueront plus aux ressources attribuées."

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "Cela arrêtera de force votre ressource « {name} ». Pour les ressources arrêtées, seuls les frais de stockage seront facturés."

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "Cela mettra en hibernation le cluster \"{display_name}\"."

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Cela n'est utilisé que dans le système, pour vous aider à reconnaître le compte si vous en avez plusieurs."

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "Cela redémarrera votre ressource « {name} »."

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "Cela supprimera l’adresse ou la plage de la liste d’adresses IP autorisées.<0/>Notez qu’une liste vide autorisera les connexions depuis n’importe quelle adresse."

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Cela arrêtera votre ressource « {display_name} ». Si l’arrêt propre ne se termine pas en 120 secondes, un arrêt forcé sera effectué. Pour les ressources arrêtées, seuls les frais de stockage seront facturés."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Cela arrêtera votre ressource « {name} ». Si l’arrêt normal ne se termine pas en 120 secondes, un arrêt forcé sera effectué. Pour les ressources arrêtées, seuls les frais de stockage seront facturés."

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "Cela arrêtera le transfert du trafic vers les cibles et supprimera l’équilibreur de charge."

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Seuil"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "Il est temps de passer à autre chose. Voici quelques idées pour la suite :"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "Il est temps de passer à autre chose. Cet élément a été supprimé ou vous n’y avez pas accès."

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Le délai d’attente d’une réponse de Razorpay a expiré"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Fuseau horaire"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "Pour activer un compte de facturation, ajoutez une carte de crédit comme moyen de paiement ou contactez le support pour activer le paiement sur facture."

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "Pour restreindre les connexions au service, vous devez ajouter au moins une IP entrante à la liste d’adresses IP autorisées (toutes les autres connexions publiques et privées seront refusées). Vous pouvez spécifier une adresse IPv4 unique ou un bloc d’adresses en notation CIDR (p. ex. 1.1.1.0/24)."

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "Pour commencer à utiliser la plateforme, vous devez d'abord configurer un compte de facturation. Vous pouvez parcourir l’interface pour vous familiariser avec le système et revenir à la création du compte de facturation lorsque vous serez prêt à créer vos premières ressources."

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "Pour utiliser nos services, vous devez accepter les Conditions d’utilisation."

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Jeton"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Recharger"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Montant du rechargement"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Rechargez au moins <0><1/></0> pour obtenir un bonus lié au code de parrainage de <2><3/></2>."

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Recharger maintenant"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Rechargez votre compte"

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Factures de rechargement"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Commandes de recharge"

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Total"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Montant total débité"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Total hors {vatSymbol}"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Total de toutes les factures impayées. Incluant {vatSymbol}."

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Total de toutes les commandes impayées. TVA incluse."

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Frais de transaction"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Type"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "Les variables UEFI (NVRAM) ne seront pas conservées après les redémarrages."

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "Interface utilisateur"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Dissocier"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Non attribuée"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Unité"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Inconnu"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "Erreur Auth0 inconnue"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Compte de facturation inconnu"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "Erreur de paiement inconnue{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Ressource inconnue"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Dissocier la cible"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Impayé"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Montant impayé"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "Non vérifié"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "Mettre à jour"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "Mettre à jour la clé SSH"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Téléverser"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Téléversez uniquement une copie du document RNE pour vérification"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Téléversement des fichiers"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "Des téléversements sont toujours en cours. Si vous quittez cette page, leur progression ne sera plus affichée et les téléversements risquent d’être interrompus. Quitter quand même ?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "Consommation"

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "Après la création de la machine virtuelle, utilisez l’option de démarrage sur ISO pour installer vous-même un système d’exploitation."

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Accès"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "L’utilisateur doit accepter l’invitation d’accès depuis sa page de profil"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Vue utilisateur"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "E-mail de l’utilisateur"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Nom d’utilisateur"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Utilisateurs auxquels j'ai accès"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Utilisateurs pouvant accéder à mon compte"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Valide jusqu’au"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Validation en attente"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "La valeur ne correspond pas au format requis"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "TVA"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "Numéro de TVA"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Vérifié"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "Aucune méthode de paiement vérifiée"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Vérification du mode de paiement"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Version"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Voir"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Afficher tous les enregistrements"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Afficher les commandes de configuration"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Voir les détails"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Afficher les {limit} derniers enregistrements"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Voir plus"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "URL de type hôte virtuel"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Machine virtuelle"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "ID VLAN"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "Plage d’IP du VPC"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "Nom du VPC"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "Réseau VPC"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "Le réseau VPC est disponible sans frais supplémentaires."

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Attendez la vérification ou ajoutez une carte"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "En attente de la confirmation du paiement"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "Le délai d’attente pour le retour de la fenêtre pop-up après la redirection a expiré"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Réveil en cours"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Avertissement"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Avertissement : il est recommandé d’arrêter la machine virtuelle avant de redimensionner le disque de démarrage."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "Nous vous recommandons d’ajouter une carte bancaire pendant le traitement de votre demande afin d’activer immédiatement les services."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "Nous recommandons la recharge automatique, car elle réduit le risque d’épuiser vos fonds et d’affecter ainsi vos ressources serveur."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "Nous avons rassemblé quelques liens pour vous aider à démarrer. Développez, testez du code et déployez vos applications en un rien de temps, du prototypage au développement à grande échelle."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "Nous avons atteint la capacité de notre explorateur de fichiers. Afin de préserver la stabilité de notre interface, nous avons arrêté le chargement du contenu de votre bucket. Veuillez utiliser des outils externes à votre disposition pour gérer le contenu de votre bucket."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Bienvenue"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "Bienvenue !<0/>Nous sommes ravis que vous soyez ici."

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "Que souhaitez-vous faire ?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "Lorsque le solde passe en dessous"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "Lorsqu’elle est réservée mais non attribuée à une ressource, l’adresse IPv4 sera facturée <0/> / mois."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "Lorsque cette option est sélectionnée, une adresse IPv4 publique flottante sera créée et attribuée automatiquement à votre ressource. Si vous ne souhaitez pas que votre ressource soit accessible publiquement, vous pouvez désélectionner l’option ici ou supprimer l’adresse IP plus tard."

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "Lorsque vous activez le service de sauvegarde, une sauvegarde automatique au niveau du disque sera créée à partir du disque de démarrage (en excluant les disques supplémentaires). Une sauvegarde sera créée une fois par semaine et sera listée ici. Vous pourrez ensuite utiliser les images de sauvegarde pour restaurer votre machine virtuelle ou créer une nouvelle machine virtuelle à partir de la sauvegarde avec des paramètres de taille modifiés."

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "Pendant l'exécution de la tâche, vous pouvez :"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "Avec un pare-feu, vous pouvez contrôler le trafic réseau entrant et sortant selon des règles de sécurité prédéfinies."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "Avec votre premier compte de facturation, vous pourrez débloquer votre crédit offert de <0><1/></0>."

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "Avec le moyen de paiement sélectionné, vous serez débité en {0}."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Sans compte de facturation actif, vous ne pouvez créer aucune ressource ; créez-en un pour commencer."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Sans compte de facturation actif, il est impossible de créer des ressources."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "année"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "Annuel"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Oui"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Vous êtes sur le point d’accéder à l’utilisateur « {name} »"

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Vous êtes administrateur et vous êtes sur le point de déléguer vos privilèges d’administration à un autre utilisateur. Veuillez vous assurer que cette action est intentionnelle."

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Vous pouvez activer l’authentification multifacteur pour renforcer la sécurité. Cela fonctionne uniquement avec la méthode de connexion identifiant‑mot de passe. Pour les méthodes de connexion sociales (Google, etc.), il est généralement possible d’activer la MFA du côté du service tiers."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Vous pouvez démarrer votre machine virtuelle à partir d’une image spéciale pour la récupération du système ou pour installer un nouveau système d’exploitation. Lorsqu’il est activé, ce mode attache l’image choisie comme support de démarrage. Vous pouvez ensuite utiliser la Console pour accéder à votre machine. Ce mode de démarrage n’est activé que pour le lancement en cours. Au prochain démarrage de cette machine virtuelle, la procédure normale sera suivie."

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Vous pouvez fermer cette page."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Vous pouvez créer plusieurs comptes de facturation, chacun lié à des modes de paiement spécifiques. Cette approche vous permet de séparer et de suivre efficacement les dépenses des différentes équipes, départements ou projets."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Vous pouvez commencer ici et poursuivre plus tard en cliquant sur le lien dans l'e-mail que nous vous envoyons."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Vous pouvez gagner et offrir des crédits en partageant votre code de parrainage unique."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "Vous ne pouvez pas ajouter une autre réservation, car une réservation future existe déjà."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "Vous vous engagez à payer le prix total pour la période sélectionnée dès que vous confirmez la réservation."

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Vous avez une adresse IP flottante <0>{0}</0> attribuée à cette ressource."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "Vous avez un code de campagne actif (<0>{referralCode}</0>) en attente pour obtenir un bonus supplémentaire !"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Une validation de compte de facturation est en cours."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Vous avez terminé le processus de validation du compte de facturation. Veuillez attendre la décision finale."

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "Vous n'avez aucune notification."

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Vous pouvez fermer cette boîte de dialogue après avoir effectué un paiement."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Vous pouvez fermer cette fenêtre de dialogue pour le moment."

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "Vous devez disposer d’au moins une clé d’accès pour parcourir les fichiers de ce bucket."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Vous pourrez configurer des moyens de paiement et utiliser les services cloud une fois la validation approuvée."

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Vous pourrez configurer des moyens de paiement et utiliser les services cloud une fois la validation terminée."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "Vous ne serez pas facturé tant qu’il ne sera pas prêt."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "Votre compte a été suspendu"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Le montant effectivement débité sera de <0/>, avec un taux de change de <1/>."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Votre compte de facturation a été suspendu. Consultez les détails du compte de facturation pour plus d’informations et <0>contactez le support</0> afin de résoudre le problème."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Votre compte de facturation a été rechargé"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Votre compte de facturation doit avoir un solde positif pour être activé."

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Votre adresse e‑mail a été vérifiée avec succès. Vous pouvez maintenant vous connecter."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Votre adresse e-mail a changé depuis le début de la validation. Veuillez recommencer."

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "Votre compte de facturation sélectionné bénéficie d'une réduction de {discount}%."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Votre bucket de stockage contient un nombre important de fichiers et nous avons temporairement interrompu le chargement. Cliquez simplement sur le bouton « Charger plus » pour continuer à charger le lot de fichiers suivant."

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Code postal"
